/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/dist/js/bootstrap.min.js';
import { useState, useEffect } from 'react';
import { Link, Outlet } from "react-router-dom";
import { ethers } from 'ethers'
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import detectEthereumProvider from '@metamask/detect-provider'
import reBurnProtocol from './artifacts/contracts/reBurnProtocol.sol/reBurnProtocol.json'
import reBurnToken from './artifacts/contracts/reBurnToken.sol/reBurnToken.json'
import Home from './routes/home.js'
import VersionCheck from './VersionCheck.js'
import globals from "./globals.js"
import Whitepaper from './whitepaper.pdf'

function App() {
    const [ethereum, setEthereum] = useState(null)
    const [web3, setWeb3] = useState(null)
    const [accounts, setAccounts] = useState(null)
    const [myTokens, setMyTokens] = useState()
    const [selectedTokenIndex, setSelectedTokenIndex] = useState() //1 -indexed
    const [chain, setChain] = useState(null);

    function shortAddress(a) {
        if (!a)
            return a;
        return a.substring(0, 6) + "..." + a.substring(a.length - 4, a.length);
    }

    async function getLP(address) {
        const lifeContract = new ethers.Contract(address, reBurnToken.abi, web3)
        const metadata = await lifeContract.metadata("staking");
//        console.log("Metadata for " + address + " is " + metadata);
        return metadata;
    }

    async function saveAddresses(addresses) {
        if (!addresses || addresses.length === 0) {
            setMyTokens([]);
            setSelectedTokenIndex(1); //or -1 or some other value?
            return;
        }

        var data = [];
        for (const add of addresses) {
           let lp = await getLP(add);
           if (lp)
               data.push({address: add, staking:[lp]})
           else
               data.push({address: add, staking:[]});
        }

        setMyTokens(data);
        if (!selectedTokenIndex)
            setSelectedTokenIndex(1);
    }

    function toChain(chainId) {
            //https://chainlist.org/
            switch (chainId) {
                case 1:
                    return "ETH";
                case 56:
                    return "BSC";
                case 97:
                    return "BSC-Test";
                case 137:
                    return "Polygon";
                case 80001:
                    return "Polygon-Test";
                case 42161:
                    return "Arbitrum";
                case 1337:
                    return "localhost";
                default:
                    return "?";
            }
    }

    if (ethereum == null) {
//        console.log("No ethereum");
        detectEthereumProvider().then(eth => {
            if (!eth)
                return;

            setEthereum(eth);
            if (web3 == null) {
                setWeb3(new ethers.providers.Web3Provider(eth));
            }
        });
    }
    let seedAddress;
    let stakingFactory;
    let airdrop;
    if (chain && globals[chain]) {
        if (globals[chain].protocol) {
            seedAddress = globals[chain].protocol;
        }
        if (globals[chain].stakingFactory) {
            stakingFactory = globals[chain].stakingFactory;
        }
        if (globals[chain].airdrop) {
            airdrop = globals[chain].airdrop;
        }
    }
    const wrongChain =
        (accounts && accounts.length !== 0) &&
        (chain && !globals[chain]);

    if(myTokens == null && accounts != null && accounts.length > 0 && web3 != null && seedAddress) {
        const seedContract = new ethers.Contract(seedAddress, reBurnProtocol.abi, web3);
        seedContract.tokens(accounts[0])
            .then(saveAddresses);
    }

    function addStakingContract(stakingAddress, tokenAddress) {
        const k = myTokens.findIndex(elem => ethers.utils.getAddress(elem.address) === ethers.utils.getAddress(tokenAddress));
        if (k === -1) {//how?
//            console.log("Count not find " + tokenAddress + " in " + myTokens);
            return;
        }
        const myTokensCopy = [...myTokens];
        if(!myTokensCopy[k].staking) {
            myTokensCopy[k].staking = [];
        }
        myTokensCopy[k].staking.push(stakingAddress);
//        console.log("Changing tokens to ");
//        console.log(myTokensCopy);
        setMyTokens(myTokensCopy);
    }

    useEffect(() => {
        if (ethereum) {
            ethereum.on('accountsChanged', setAccounts);
            ethereum.on('chainChanged', window.location.reload);
            ethereum.request({ method: 'eth_accounts' })
                .then(setAccounts);
            ethereum.request({ method: 'eth_chainId' })
//                .then(console.log);
                .then(id => setChain(toChain(parseInt(id, 16))));
        }
        return function cleanup() {
            if (ethereum) {
                ethereum.removeListener('accountsChanged', setAccounts);
                ethereum.removeListener('chainChanged', window.location.reload);
            }
        };
    }, [ethereum]);

    async function requestAccount() {
        ethereum.request({ method: 'eth_requestAccounts' })
            .then(setAccounts);
    }

//Note: fixed="top" nav needs all kinds of workarounds like body padding-top: 60px; *and* gets in the way of the URI check alert
  return (
    <div className="App">
     <Navbar variant="dark" bg="dark" expand="lg">
        <Container>
        <Navbar.Brand>
            <Link to="/" className="navbar-brand">
               reBURN Protocol✨
            </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNavDropdown" />
        <Navbar.Collapse id="navbarNavDropdown">
            <Nav>
                {(web3) &&
                    <>
                    {accounts &&
                    <Nav.Link as={Link} to="/create">Create</Nav.Link>
                    }
                    <NavDropdown menuVariant="dark" title="Manage" id="manage-nav-dropdown">
                        <NavDropdown.Item as={Link} to="/metadata">Edit Metadata</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/createstaking">Create staking contract</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/airdrop">Airdrop</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/source">Source code</NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link as={Link} to="/farm">Farm</Nav.Link>
                    <Nav.Link as={Link} to="/burn">Swap</Nav.Link>
                    </>
                }
                <NavDropdown menuVariant="dark" title="About" id="about-nav-dropdown">
                  <Nav.Link href={Whitepaper}>Whitepaper</Nav.Link>
                </NavDropdown>
            </Nav>
          <div className="ms-auto">
                {(myTokens && selectedTokenIndex && myTokens[selectedTokenIndex - 1]) &&
                    <Nav>
                    <NavDropdown menuVariant="dark" title={shortAddress(myTokens[selectedTokenIndex - 1].address)} id="collasible-nav-dropdown">
                        {
                        myTokens.map((token, index) => (
                            <NavDropdown.Item key={index} onClick={() => {
                                    setSelectedTokenIndex(index + 1);
                                }}>
                                {(index === selectedTokenIndex - 1) && <span>✔</span>}
                                {token.address}
                            </NavDropdown.Item>
                        ))
                        }
                    </NavDropdown>
                    </Nav>
                }
          </div>
          <div>
          <Nav>
                {wrongChain && <span className="badge rounded-pill bg-warning" alt="Change network {chain} unsupported">Change network</span>}
          </Nav>
          </div>
          <div className="ms-auto">
            <Nav>
                {ethereum ?
                ((accounts == null || accounts.length === 0) ?
                <button className="btn btn-outline-success my-2 mx-2 my-sm-0" onClick={requestAccount}>Connect</button>
                :
                <>
                {/*
                <button className="btn btn-sm btn-outline-secondary my-2 mx-2 my-sm-0">{chain}</button>
                <button className="btn btn-outline-success my-2 mx-2 my-sm-0">{chain} {shortAddress(accounts[0])}</button>
                */}
                <NavDropdown menuVariant="dark" title={shortAddress(accounts[0])} id="user-nav-dropdown">
                    <NavDropdown.ItemText>On {chain}</NavDropdown.ItemText>
                     {(myTokens && selectedTokenIndex && myTokens[selectedTokenIndex - 1]) &&
                        <>
                        <NavDropdown.Divider />
                        <NavDropdown.ItemText>Tokens:</NavDropdown.ItemText>
                        {
                        myTokens.map((token, index) => (
                            <NavDropdown.Item key={index} onClick={() => {setSelectedTokenIndex(index + 1)}}>
                                {(index === selectedTokenIndex - 1) && "✔"}
                                {shortAddress(token.address)}
                            </NavDropdown.Item>
                        ))
                        }
                        </>
                        }
                    {/*  TODO: disconnect
                    <NavDropdown.Divider />
                    <NavDropdown.Item>Disconnect</NavDropdown.Item> */}
                </NavDropdown>
                </>
                ) :
                <button className="btn btn-outline-success my-2 mx-2 my-sm-0" disabled>Install MetaMask to use</button>
                }
            </Nav>
          </div>
        </Navbar.Collapse>
        </Container>
     </Navbar>

     <div className="jumbotron container">
       {(web3 && seedAddress) &&
        <VersionCheck web3={web3} seedAddress={seedAddress} />
       }
       {(web3 && myTokens) ?
        <Outlet context={[web3, seedAddress, accounts, myTokens, setMyTokens, selectedTokenIndex, addStakingContract, stakingFactory, airdrop]} />
        :
        <Home/>
       }
    </div>

    <hr/>
    <div className="container">
      <footer><p>Copyright &copy; 2021, 2022 Tropyc Stoic <br/>38c316a1b8d7188d059c273d892b723b</p></footer>
    </div>
  </div>
  );
}

export default App;
